// extracted by mini-css-extract-plugin
export default {"row":"styles_row__CVSZy","col-name":"styles_col-name__qD2qw"};